// Library Class
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { SeedReturnService } from '../../../../services/seed/seed-return.service';

// Class
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-seed-returns-soybean-zero-dumps',
  templateUrl: './seed-returns-soybean-zero-dumps.component.html',
  styleUrls: ['./seed-returns-soybean-zero-dumps.component.scss']
})

export class SeedReturnsSoybeanZeroDumpsComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('returnRequestTable', { read: MatSort }) returnRequestSort: MatSort;
  @ViewChild('returnRequestPaginator', { read: MatPaginator }) returnRequestPaginator: MatPaginator;
  returnRequestDataSource: MatTableDataSource<any>;
  tabNode: string;
  editToolKit = false;
  isSearchClicked: any;
  showTabs = false;
  selectedCount = 0;
  returnRequestList: any = [];
  dsmInfo: string;
  selectedAccountName: any = '';
  shipToAccount: number;
  subscription = new Array<Subscription>();
  dsmId = 0;
  breadcrumbtext: string;
  headerCompany = MasterConstants.US_COMPANYCODE;
  shipToAccountItems: any[];
  CloneShipToAccountItems: any[];
  shipToDataLoading = true;
  shipToAccountName: number;
  isAllAccountsChecked = false;
  checkBoxCount: number;
  displayedColumns: string[] = ['checkbox', 'accountNumber', 'accountName', 'parentNumber', 'parentAccountName', 'isName'];
  impDisplayName: any;

  constructor(private seedReturnService: SeedReturnService, private localStorageService: LocalStorageService, private loaderService: LoaderService, private toastrService: ToastrService, private router: Router) { }

  ngOnInit(): void {
    this.breadcrumbtext = 'Create Zero Dumps to Report';
    this.getAccountList();
    this.isAllAccountsChecked = false;
    if (this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel)) {
      let salesGenericLevel = JSON.parse(this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel));
      this.impDisplayName = salesGenericLevel.find(x => x.data == MasterConstants.WF_Impl_SplList_Display).value;
    }
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    const createTemplateHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.create-return-outer').css('max-height', createTemplateHeight + 'px');
  }

  getAccountList() {
    this.subscription.push(this.seedReturnService.getAccountList().subscribe((result: any[]) => {
      this.shipToAccountItems = result;
      this.CloneShipToAccountItems = result;
      this.shipToDataLoading = false;
      if (this.shipToAccount) {
        const accountItem = this.shipToAccountItems.filter(x => x.accountNumber === this.shipToAccount);
        if (accountItem && accountItem.length > 0) {
          this.selectedAccountName = accountItem[0].accountName;
          this.shipToAccountName = accountItem[0].accountName;
        }
      }
      // this.loaderService.setLoaderStatus(false);
    }, ((error) => {
      this.loaderService.setLoaderStatus(false);
      this.shipToDataLoading = false;
    })));
  }

  getShipTo(event) {
    if (event) {
      this.dsmInfo = '';
      this.selectedAccountName = event.accountName;
      this.shipToAccount = event.accountNumber;
      this.seedReturnService.setSelectedAccountNo(event.accountNumber);
      this.seedReturnService.setSelectedParentAccountNo(event.parentNumber);
    }
    this.checkBoxCount = 0;
    this.enableAllCheckBoxes(false);
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  addAccountsToDetailGrid(isLinkedAccount: boolean) {
    if (this.shipToAccount == undefined) { return false; }
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.seedReturnService.getAccountDetailsforZeroDump(this.shipToAccount, isLinkedAccount).subscribe((result: any[]) => {
      let currRow = 1;
      result.forEach(x => {
        if (this.returnRequestList.filter(y => y.accountNumber == x.accountNumber).length <= 0) {
          const newRow = {
            isSelected: false,
            rowId: currRow,
            accountNumber: x.accountNumber,
            accountName: x.accountName,
            city: x.city,
            state: x.state,
            parentNumber: x.parentNumber,
            parentAccountName: x.parentAccountName,
            isName: x.isName,
            isAccountNumber: x.isAccountNumber
          }
          currRow = currRow + 1;
          this.returnRequestList.push(newRow);
          this.shipToAccountItems = this.shipToAccountItems.filter(y => y.accountNumber != x.accountNumber);
        }
      });

      this.returnRequestDataSource = new MatTableDataSource(this.returnRequestList);
      this.returnRequestDataSource.paginator = this.returnRequestPaginator;
      this.returnRequestDataSource.sort = this.returnRequestSort;

      this.shipToAccountItems = this.shipToAccountItems.filter(x => x.accountNumber != this.shipToAccount);
      this.shipToAccount = null;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    }));
  }

  submitZeroDumpRequest() {
    this.loaderService.setLoaderStatus(true);
    var accountNumbers: any[] = this.returnRequestList.map(x => x.accountNumber);
    this.subscription.push(this.seedReturnService.saveNonSoybeanZeroDump(accountNumbers).subscribe((result: any) => {
      if (result) {
        this.toastrService.success('Request placed successfully.');
        this.seedReturnService.webOrderNumberAndSplitId = result.jdeOrderNumber + '-' + 0 + '- ' + '-SeedReturn';// Done '- ' so that we could show non errored data
        this.router.navigate(['/seed-returns-soybean-dashboard']);
        this.loaderService.setLoaderStatus(false);
      }
      else {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Request not saved in the system.');
      }
    }));
  }
  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  SetAllFields(value: any) {
    if (value == true) {
      this.deleteSelectedAccount();
      this.editToolKit = false;
      this.showTabs = false;
    } else {
      this.editToolKit = true;
      this.showTabs = true;
    }
    this.tabNode = '';
  }

  enableAllCheckBoxes(isChecked) {
    this.isAllAccountsChecked = isChecked;
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;
      this.returnRequestDataSource.filteredData.forEach(x => {
        x.isSelected = true;
      });

      this.checkBoxCount = this.returnRequestDataSource?.filteredData?.filter(x => x.isSelected == true).length;
      const selectedItem = this.returnRequestDataSource?.filteredData?.filter(x => x.isSelected == true);
      if (selectedItem && selectedItem.length > 0) {
        this.editToolKit = true;
      }
      else {
        this.editToolKit = false;
      }
      this.selectedCount = this.checkBoxCount;
    }
    else {
      this.showTabs = false;
      this.editToolKit = false;
      this.returnRequestDataSource?.filteredData?.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;
      this.selectedCount = this.selectedCount + 1
      this.checkBoxCount = this.returnRequestDataSource.filteredData.filter(x => x.isSelected == true).length;
      const checked = this.returnRequestDataSource.filteredData.filter(x => x.isSelected == false);

      if (checked && checked.length == 0) {
        this.isAllAccountsChecked = true;
      }
      else {
        this.isAllAccountsChecked = false;
      }
    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      const checked = this.returnRequestDataSource.filteredData.filter(x => x.isSelected == true);
      {
        if (checked && checked.length == 0) {
          this.showTabs = false;
        }
      }
      this.isAllAccountsChecked = false;
      this.selectedCount = this.selectedCount - 1;
    }
  }

  // Update the data after delete the selected row
  deleteSelectedAccount() {
    this.returnRequestList = [];
    var matchingItems = [];
    let currRow = 1;
    this.returnRequestDataSource.data.forEach(x => {
      if (x.isSelected == true) {
        this.selectedCount = this.selectedCount - 1;
      } else {
        const newRow = {
          isSelected: false,
          rowId: currRow,
          accountNumber: x.accountNumber,
          accountName: x.accountName,
          city: x.city,
          state: x.state,
          parentNumber: x.parentNumber,
          parentAccountName: x.parentAccountName,
          isName: x.isName,
          isAccountNumber: x.isAccountNumber
        }
        currRow = currRow + 1,
          this.returnRequestList.push(newRow);
      }
    });
    this.returnRequestDataSource = new MatTableDataSource(this.returnRequestList);
    this.returnRequestDataSource.paginator = this.returnRequestPaginator;
    this.returnRequestDataSource.sort = this.returnRequestSort;
    this.shipToAccountItems.push(...matchingItems);
    this.shipToAccountItems = this.returnRequestList.length > 0 ? this.CloneShipToAccountItems.filter(x => !this.returnRequestList.find(y => y.accountNumber == x.accountNumber)) : this.CloneShipToAccountItems;;
  }

  // Page destroy event
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
